import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authApi } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(null);   // { role, user_info, redirect_to }
  const [loading, setLoading] = useState(true);

  // On app load, restore session from localStorage token
  useEffect(() => {
    const token = localStorage.getItem('pb_auth_token');
    if (!token) { setLoading(false); return; }

    authApi.me()
      .then(data => setAuth(data))
      .catch(() => {
        localStorage.removeItem('pb_auth_token');
        setAuth(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const loginAdmin = useCallback(async (username, password) => {
    const data = await authApi.loginAdmin(username, password);
    localStorage.setItem('pb_auth_token', data.token);
    setAuth(data);
    return data;
  }, []);

  const loginCourt = useCallback(async (pin) => {
    const data = await authApi.loginCourt(pin);
    localStorage.setItem('pb_auth_token', data.token);
    setAuth(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await authApi.logout(); } catch { /* ignore */ }
    localStorage.removeItem('pb_auth_token');
    setAuth(null);
  }, []);

  return (
    <AuthContext.Provider value={{ auth, loading, loginAdmin, loginCourt, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
